import { Component, Injector, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { MESSAGE_RESET_PASSWORD, show_popup, TITLE_RESET_PASSWORD } from '@shared/utility/popup-error';

import { ResetPasswordService } from '@account/services/resetPassword.service';
import { NavigationService } from '@home/services';
import { ResetPasswordRequest } from '@model/resetPasswordRequest';
import { ResetPasswordUserResponse } from '@model/resetPasswordUserResponse';

@Component({
  selector: 'app-restore-password',
  templateUrl: './restore-password.component.html',
  styleUrls: ['./restore-password.component.css'],
})
export class RestorePasswordComponent implements OnInit {
  @Input('key') key: string;

  private readonly formBuilder: FormBuilder;
  private readonly resetPasswordService: ResetPasswordService;
  private readonly navigationService: NavigationService;

  form: FormGroup;
  request: ResetPasswordRequest;
  response: ResetPasswordUserResponse;
  isMessageError: boolean = false;
  messageError: string;

  constructor(private injector: Injector) {
    this.resetPasswordService = this.injector.get(ResetPasswordService);
    this.formBuilder = this.injector.get(FormBuilder);
    this.navigationService = this.injector.get(NavigationService);
  }

  public ngOnInit(): void {
    this.initForm();
  }

  private initForm() {
    this.form = this.formBuilder.group(
      {
        password: new FormControl('', [Validators.required, Validators.minLength(6)]),
        confirmPassword: new FormControl(''),
      },
      { validators: this.checkPasswords }
    );
  }

  changePassword() {
    this.request = new ResetPasswordRequest(this.key, this.form.value.password, this.form.value.confirmPassword);

    this.resetPasswordService.resetPassword(this.request).subscribe(
      (res) => {
        this.response = res;
        if (this.response.status) {
          show_popup(TITLE_RESET_PASSWORD, MESSAGE_RESET_PASSWORD).then(() => {
            if (this.response.status) {
              window.location.href = this.response.redirect;
            }
          });
          return true;
        } else {
          this.isMessageError = true;
          this.messageError = this.response?.message;
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  checkPasswords(group: FormGroup) {
    // here we have the 'passwords' group
    const password = group.get('password').value;
    const confirmPassword = group.get('confirmPassword').value;

    return password === confirmPassword ? null : { notSame: true };
  }

  public redirectToLogin(): void {
    this.navigationService.redirectToLogin();
  }
}
